import React from 'react';
import { COMPARE_PRICE, MOCKUP_URL, PRICE, PRODUCT_NAME } from '../data/config';
import { purchaseAssurances } from '../data/kit';
import { CTAButton, Section, Tag } from './Shared';
export function FinalOffer() {
  return <Section id="oferta-final" tone="cream" data-id="element-67" data-mp="1gh6shivkwad8">
      <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14" data-id="element-68" data-mp="1ge2j8739aofp">
        <img src={MOCKUP_URL} alt="Kit Disfraces de Halloween completo: 2 tomos y 5 bonus" loading="lazy" className="mx-auto h-auto w-full max-w-[480px] drop-shadow-xl" draggable={false} data-id="element-69" data-mp="1cdijcvrat6pv" />

        <div className="text-center lg:text-left" data-id="element-70" data-mp="1leyvb7xrhgw7">
          <Tag variant="white" data-id="element-71" data-mp="2044rso57st0e">🎃 TODO EL KIT EN UNA SOLA COMPRA</Tag>
          <h2 className="mt-4 text-[32px] font-extrabold leading-[1.1] text-brand-violet md:text-5xl" data-id="element-72" data-mp="206h52o012f74">{PRODUCT_NAME}</h2>
          <p className="mt-2 text-xl font-bold text-brand-orangeDark" data-id="element-73" data-mp="2952p6nl5e2a0">2 tomos + 5 bonus</p>
          <p className="mt-2 text-base font-medium text-brand-ink/80" data-id="element-74" data-mp="245zsprj8h4dn">7 PDFs · 140 páginas · 16 propuestas de disfraces</p>

          <div className="mt-6 flex items-baseline justify-center gap-4 lg:justify-start" data-id="element-75" data-mp="1pyph2lttvlc">
            <span className="text-xl font-bold text-brand-ink/55 line-through" data-id="element-76" data-mp="6oa55tysz0bh">{COMPARE_PRICE}</span>
            <span className="font-display text-5xl font-extrabold text-brand-violet md:text-6xl" data-id="element-77" data-mp="bn3h3hyfyj9j">
              {PRICE}
              <span className="ml-1 text-xl md:text-2xl" data-id="element-78" data-mp="gnr4ltngohz0">ARS</span>
            </span>
          </div>

          <CTAButton className="mt-6" data-id="element-79" data-mp="kn9s8x6o375j">QUIERO CREAR ESTE HALLOWEEN EN FAMILIA →</CTAButton>
          <p className="mt-3 text-sm font-medium text-brand-ink/75" data-id="element-80" data-mp="pmmb76uf3u2u">Pago único · Formato PDF · Materiales no incluidos</p>
          <ul className="mt-4 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-81" data-mp="uffjg4p3hkjo">
            {purchaseAssurances.map(item => <li key={item} className="rounded-full bg-white px-3 py-1.5 text-sm font-bold text-brand-violet shadow-card" data-id="element-82" data-mp="zcfqahtrqrbu">
                {item}
              </li>)}
          </ul>

          <p className="mt-8 rounded-2xl bg-white p-5 text-left text-base leading-relaxed text-brand-ink shadow-card" data-id="element-83" data-mp="18ef5d4l83lc5">
            <strong className="text-brand-violet" data-id="element-84" data-mp="35cfadzqh0ds8">P.D.:</strong> Podés empezar por el personaje que más les guste. No
            hace falta realizar todos los proyectos para disfrutar el kit.
          </p>
        </div>
      </div>
    </Section>;
}